import React from 'react';
import { Button, message, Layout } from 'antd';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { getWallet } from '../../common/fetch';
import {
	// VAULT_IMAGE,
	ICON_CHARGE,
	// ICON_WALLET,
	// ICON_SEARCH,
	// ICON_KEY,
	// ICON_RESTORE,
	// XHT_ICON_BLUE,
	WALLET_SELECTED,
	WALLET_BLUE_SELECTED,
	ICON_LIST
} from '../../config/media';
import Wrapper from './style';
import {
	Cotainer,
	InfoSection,
	MainSection
} from '../../components/AppWrapper';
import CreateWallet from '../CreateWallet';
import UpgradeModal from '../../components/UpgradeModal';
// import Popup from '../../components/Popup';
import SideBar from '../../components/SideBar';
import { UserAction } from '../../actions';

import AssetList from './AssetList';
import MyWallets from './MyWallets';
import TokenList from './TokenList';
import WalletDeatil from '../WalletDetail';

// const { Option } = Select;
const { Content } = Layout;

class WalletList extends React.Component {
	state = {
		name: '',
		currency: '',
		data: [],
		pagination: { current: 1, total: 0 },
		loading: false,
		step: 1,
		pageType: 1,
		mobileToggle: false,
		pin: '',
		isFetching: false,
		isDelete: false
	};

	componentDidMount() {
		// this.getWallet();
	}

	componentWillReceiveProps() {
		// this.getWallet();
	}

	getWallet = (page = 1) => {
		const { name, currency } = this.state;
		this.setState({ loading: true }, async () => {
			try {
				const res = await getWallet(page, name, currency);
				const data = res.data.data.sort((a, b) => {
					const AD = new Date(a.created_at);
					const BD = new Date(b.created_at);
					return AD >= BD ? -1 : 1;
				});
				const pagination = { ...this.state.pagination };
				pagination.total = res.data.count;
				this.setState({
					loading: false,
					data,
					pagination,
					pageType: data.length === 0 ? 1 : 2
				});
			} catch (error) {
				message.error(error.data.message);
				this.setState({ loading: false });
			}
		});
	};

	search = () => {
		const { name } = this.state;
		if (name === '') {
			return;
		}
		this.getWallet(1);
	};

	handleChange = (e) => {
		const { name, value } = e.target;
		this.setState({ [name]: value });
	};

	handleKeyPress = (e) => {
		if (e.which === 13) {
			this.search();
		}
	};

	handleSelect = (v) => {
		this.setState(
			{
				currency: v
			},
			() => {
				this.getWallet(1);
			}
		);
	};

	handleDelete = () => {
		this.getWallet(this.state.pagination.current);
	};

	handleTableChange = (pagination, filters, sorter) => {
		const pager = { ...this.state.pagination };
		pager.current = pagination.current;
		this.setState({
			pagination: pager
		});
		this.getWallet(pagination.current);
	};
	// TODO
	// Create restore wallet
	createWallet = (wallet = '') => {
		const { verification_level } = this.props.user;
		const { history } = this.props;
		const { data } = this.state;
		if (verification_level < 3 && data.length > 4) {
			history.push('/wallet/upgrade');
		} else {
			const obj = {
				pathname: '/wallet/new',
				state: { type: 'new', currency: 'btc' }
			};
			if (typeof wallet === 'string') {
				obj.state.currency = wallet;
			}
			history.push(obj);
		}
	};
	// TODO
	// Unlock restore wallet
	restoreWallet = (wallet = '') => {
		const { verification_level } = this.props.user;
		const { history } = this.props;
		const { data } = this.state;
		if (verification_level < 3 && data.length > 4) {
			history.push('/wallet/upgrade');
		} else {
			const obj = {
				pathname: '/wallet/new',
				state: { type: 'restore', currency: 'btc' }
			};
			history.push(obj);
		}
	};

	onDeleteWallet = () => {
		this.setState({ isDelete: false }, () => {
			this.props.history.goBack();
		});
	};

	renderBody = () => {
		const {
			pagination,
			data,
			loading,
			name,
			currency,
			pageType
		} = this.state;
		const { location } = this.props;

		if (
			location.pathname.length >= 10 &&
			!(location.pathname.indexOf('upgrade') >= 0) &&
			!(location.pathname.indexOf('new') >= 0) &&
			!(location.pathname.indexOf('api-key') >= 0)
		) {
			return (
				<WalletDeatil
					walletData={data}
					isDelete={this.state.isDelete}
					onDelte={this.onDeleteWallet}
				/>
			);
		}
		if (location.pathname.indexOf('api-key') >= 0) {
			return <TokenList {...this.props} />;
		}
		if (pageType === 1) {
			return <AssetList {...this.props} createWallet={this.createWallet} />;
		}
		if (pageType === 2) {
			return (
				<MyWallets
					{...this.props}
					pagination={pagination}
					data={data}
					loading={loading}
					name={name}
					onClick={this.createWallet}
					onSearch={this.search}
					onSelect={this.handleSelect}
					onChange={this.handleChange}
					onDelete={this.handleDelete}
					onKeyPress={this.handleKeyPress}
					handleTableChange={this.handleTableChange}
					currency={currency}
				/>
			);
		}
		if (pageType === 3) {
			return <TokenList {...this.props} />;
		}
	};

	render() {
		const { step, mobileToggle } = this.state;
		const { location, history } = this.props;
		// const { verification_level } = this.props.user;
		// let title = '';
		// let label = '';
		// let description =
		// 	'You create your mainnet or testest wallets on this page by simply clicking the create wallet button. Light Wallet can create one for each asset.';
		// // let imgSrc = '';
		// if (verification_level >= 4) {
		// 	title = 'Vault Enterprise Wallet';
		// 	label = 'enterprise';
		// 	// imgSrc = WALLET_ENTERPRISE_PACK;
		// } else if (verification_level === 3) {
		// 	title = 'Vault Business Wallet';
		// 	label = 'business';
		// 	// imgSrc = WALLET_BUSINESS_PACK;
		// } else {
		// 	title = 'Vault Lite Wallet';
		// 	label = 'lite';
		// 	description =
		// 		'Both testnet and mainnet crypto wallets can be created at here, by simply selecting the asset you want. There will be certain restrictions for Lite Wallets and you would require to request for upgrading it to Business Wallet.';
		// 	// imgSrc = WALLET_LITE_PACK;
		// }

		const ButtonProps = {
			style: { width: '150px' },
			block: true,
			type: 'primary'
		};
		// const OptionImgProps = {
		// 	height: '15px',
		// 	verticalAlign: 'middle',
		// 	marginRight: '8px'
		// };

		// let isDetail =
		// 	location.pathname.indexOf('wallet/') >= 0 &&
		// 	location.pathname.indexOf('upgrade') < 0 &&
		// 	location.pathname.indexOf('api-key') < 0 &&
		// 	location.pathname.indexOf('new') < 0;

		return (
			<Cotainer>
				<Layout>
					<SideBar>
						<InfoSection className={mobileToggle ? 'less-content on' : 'less-content'}>
							<div>
								<div className="info-title-wrapper">
									<img src={WALLET_SELECTED} alt="logo" className="title-icon" />
									<h3 className="title-label">Account Wallet</h3>
								</div>
								<p>Deposit coins in your account wallet and use it to pay for crypto services. Using crypto such as XHT will grant discounts on purchases.</p>

								<Button
									{...ButtonProps}
									onClick={() => {
										if (window.innerWidth < 1200) {
											this.setState({ mobileToggle: false });
										}
										// if (location.pathname === '/wallet') {
										// 	this.setState({ pageType: 2 });
										// } else {
										// 	history.goBack();
										// }
									}}
								>
									<img src={WALLET_BLUE_SELECTED} alt="icon" />
									Wallet Balance
								</Button>
								{/*<Button
									{...ButtonProps}
									onClick={() => {
										if (window.innerWidth < 1200) {
											this.setState({ mobileToggle: false });
										}
										history.push('/wallet/upgrade');
									}}
								>
									<img src={ICON_CHARGE} alt="icon" />
									Upgrade
								</Button>*/}
								<Button
									{...ButtonProps}
									onClick={() => {
										history.push('/credit');
										// if (location.pathname === '/wallet') {
										// 	this.setState({ pageType: 1 });
										// } else {
										// 	history.goBack();
										// }
									}}
								>
									<img src={ICON_CHARGE} alt="icon" />
									Charge XHT
								</Button>
								<Button
									{...ButtonProps}
									onClick={() => {
										if (window.innerWidth < 1200) {
											this.setState({ mobileToggle: false });
										}
										// history.push('/wallet/api-key');
									}}
								>
									<img src={ICON_LIST} alt="icon" />
									Wave Auction
								</Button>
								<Button
									{...ButtonProps}
									onClick={() => {
										if (window.innerWidth < 1200) {
											this.setState({ mobileToggle: false });
										}
										// history.push('/wallet/api-key');
									}}
								>
									<img src={ICON_LIST} alt="icon" />
									Learn More
								</Button>
								{/* <Button
									{...ButtonProps}
									onClick={() => {
										if (window.innerWidth < 1200) {
											this.setState({ mobileToggle: false });
										}
										this.restoreWallet();
									}}
								>
									<img src={ICON_RESTORE} alt="icon" />
									Restore Wallet
								</Button>
								<Button
									{...ButtonProps}
									onClick={() => {
										const obj = {
											pathname: '/credit',
											state: { account: true }
										};
										history.push(obj);
									}}
								>
									<img src={XHT_ICON_BLUE} alt="icon" />
								XHT Wallet
							</Button> */}
								{/* {isDetail && (
							<Button
								style={{ width: '150px' }}
								block={true}
								type="danger"
								onClick={() => {
									this.setState({
										isDelete: true
									});
								}}
							>
								<Icon type="delete" />
								Delete Wallet
							</Button>
						)} */}
								{/* <Select defaultValue="My Wallet">
									<Option
										value="My Wallet"
										onClick={() => {
											const obj = {
												pathname: '/credit',
												state: { account: true }
											};
											history.push(obj);
										}}
									>
										<img
											style={OptionImgProps}
											src={ICON_WALLET}
											alt="icon"
										/>
										My Wallet
									</Option>
									<Option
										value="Vault Wallets"
										onClick={() => {
											if (window.innerWidth < 1200) {
												this.setState({ mobileToggle: false });
											}
											if (location.pathname === '/wallet') {
												this.setState({ pageType: 2 });
											} else {
												history.goBack();
											}
										}}
									>
										<img
											style={OptionImgProps}
											src={ICON_WALLET}
											alt="icon"
										/>
										Vault Wallets
									</Option>
									{verification_level < 4 && (
										<Option
											value="Upgrade"
											onClick={() => {
												if (window.innerWidth < 1200) {
													this.setState({ mobileToggle: false });
												}
												history.push('/wallet/upgrade');
											}}
										>
											<img
												style={OptionImgProps}
												src={ICON_CHARGE}
												alt="icon"
											/>
											Upgrade
										</Option>
									)}
									<Option
										value="Asset List"
										onClick={() => {
											if (location.pathname === '/wallet') {
												this.setState({ pageType: 1 });
											} else {
												history.goBack();
											}
										}}
									>
										<img
											style={OptionImgProps}
											src={ICON_SEARCH}
											alt="icon"
										/>
										Asset List
									</Option>
									<Option
										value="API Keys"
										onClick={() => {
											if (window.innerWidth < 1200) {
												this.setState({ mobileToggle: false });
											}
											history.push('/wallet/api-key');
										}}
									>
										<img style={OptionImgProps} src={ICON_KEY} alt="icon" />
										API Keys
									</Option>
									<Option
										value="Restore Wallet"
										block
										type="primary"
										onClick={this.restoreWallet}
										className="btn-restore"
									>
										<img
											style={OptionImgProps}
											src={ICON_RESTORE}
											alt="icon"
										/>
										Restore Wallet
									</Option>
								</Select> */}
							</div>
						</InfoSection>
					</SideBar>
					<Content>
						<MainSection>
							<Wrapper>
								{this.renderBody()}
								<UpgradeModal
									visible={location.pathname.indexOf('upgrade') >= 0}
									step={step}
									handleCancel={history.goBack}
									handleOk={history.goBack}
								/>
								<CreateWallet
									visible={location.pathname.indexOf('new') >= 0}
									title={'Create Wallet'}
									location={location}
									onOk={history.goBack}
									onCancel={history.goBack}
								/>
							</Wrapper>
						</MainSection>
					</Content>
				</Layout>
			</Cotainer>
		);
	}
}

const mapStateToProps = (state) => ({
	coins:state.coin,
	balance: state.user.balance,
	crypto_wallet: state.user.crypto_wallet
});

const mapDispatchToProps = (dispatch) => ({
	userAction: bindActionCreators(UserAction, dispatch),
});

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(WalletList);
